import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { App } from '@gin-betting/core';

import { useMemoSelector } from 'hooks';
import { changeOddsStatisticView } from '../../actions';
import { selectOddsStatisticView } from '../../selectors';

interface Output {
    show: boolean;
    statisticView: App.OddStatisticView;
    handlerStatisticToggle: () => void;
    makeOnClick: (selectedStatisticView: App.OddStatisticView) => () => void;
}

const useOddsStatisticSelect = (): Output => {
    const dispatch = useDispatch();
    const { statisticView, show } = useMemoSelector(selectOddsStatisticView);

    const handlerStatisticToggle = useCallback(() => {
        dispatch(changeOddsStatisticView({ show: !show }));
    }, [dispatch, show]);

    const makeOnClick = useCallback(
        (selectedStatisticView: App.OddStatisticView) => () => {
            dispatch(
                changeOddsStatisticView({
                    statisticView: selectedStatisticView,
                })
            );
        },
        [dispatch]
    );

    return {
        show,
        statisticView,
        handlerStatisticToggle,
        makeOnClick,
    };
};

export default useOddsStatisticSelect;
